import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logoimage from "./assets/logo.gif"; // Corrected import path
import Header from "./assets/header.png";
import StickyNavbar from './StickyNavbar'; // Import the StickyNavbar component
import HomeSearchbarTop from "../Components/HomeSearchbarTop";
import { FaBuilding, FaShoppingCart, FaQuestionCircle } from "react-icons/fa";
import { FaLandmark, FaCreditCard } from "react-icons/fa";
import instagram from "./assets/instagram.png";
import Tiktoks from "./assets/tiktok.webp";
import fb from "./assets/fb.png";

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [japaneseTime, setJapaneseTime] = useState("");
    const [thailandTime, setThailandTime] = useState("");
    const navbarRef = useRef(null); // Ref for the navbar

    // Update Japanese time every second
    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const options = {
                timeZone: "Asia/Bangkok",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false
            };
            setThailandTime(
                new Intl.DateTimeFormat("en-GB", options).format(now)
            );
        };

        const intervalId = setInterval(updateTime, 1000);
        updateTime(); // Call immediately to avoid delay
        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);

    // Close navbar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                setShowMenu(false); // Close the navbar
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup event listener
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
        <div className="container-fluid">
            <img src={Header} alt="Saad Motors" className="headerTop" />
        </div>
            {/* Top Bar */}
            <StickyNavbar />
            <div className="topbar">
                <span>Thailand Time: {thailandTime}</span>
                <span><NavLink to="/company-profile/">Support</NavLink></span>
                <span><NavLink to="/admin-panel">Login</NavLink></span>
            </div>
                
            {/* Navbar */}
          <div className="container-fluid">
              <nav className="navbar" ref={navbarRef}>
                <div className="col-lg-4 col-md-4">
                    <div className="logo">
                        <NavLink to="/">
                            <img src={logoimage} alt="Saad Motors" className="logo-image" />
                            <p><b>SAAD MOTORS (THAILAND) CO.,LTD </b> <br /> VEHICLE EXPORTING COMPANY</p>
                        </NavLink>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="mb-2">
                        <HomeSearchbarTop />
                        <ul className="menu">
                            <li>
                                <NavLink to="/company-profile">
                                    <FaBuilding className="me-2" />
                                    Company Profile
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/how-to-buy">
                                    <FaShoppingCart className="me-2" />
                                    How To Buy
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/banking-details">
                                    <FaCreditCard className="me-2" />
                                    Banking Details
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/faq-page">
                                    <FaQuestionCircle className="me-2" />
                                    FAQ
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                 <div className="col-lg-2 col-md-2">
                    <div className="row">
                        <div className="col-2">
                            <a href="https://www.facebook.com/SaadMotorsThailand" target="_blank">
                            <img src={fb} alt="facebook" className="social-image" /></a>
                        </div>
                        <div className="col-2">
                            <a href="https://www.instagram.com/saad_.motors/" target="_blank">
                            <img src={instagram} alt="instagram" className="social-image" /></a>
                        </div>
                        <div className="col-2">
                            <a href="https://www.tiktok.com/@saad.motors.thailand?_r=1&_t=ZS-99QxUU82EsM" target="_blank">
                                <img src={Tiktoks} alt="Tiktok" className="social-image" />
                            </a>
                        </div>
                        
                    </div>
                 </div>
                {/* Toggle Button */}
                {/* <div className="toggle">
                    <button className="toggle-button" onClick={() => setShowMenu(!showMenu)}>
                        ☰
                    </button>
                </div> */}

                {/* <ul className={`nav-items ${showMenu ? "show" : ""}`}> */}
                <ul className={`nav-items ${showMenu ? "d-block" : "d-none"}`}>
                    <li className="dropdown">
                        <NavLink to="/" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Home
                        </NavLink>
                    </li>
                    <li className="dropdown">
                        <NavLink to="/search-cars" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Search Car
                        </NavLink>
                    </li>
                    <li className="dropdown">
                        <NavLink to="/banking-details" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Banking Details
                        </NavLink>
                    </li>
                    {/* <li className="dropdown">
                        <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Services
                        </NavLink>
                        <ul className="dropdown-menu">
                            <li><NavLink to="/chassis-check">Chassis Check</NavLink></li>
                            <li><NavLink to="/shipping">Shipping Schedule</NavLink></li>
                        </ul>
                    </li> */}
                    <li className="dropdown">
                        <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            About Us
                        </NavLink>
                        <ul className="dropdown-menu">
                            <li><NavLink to="/company-profile">Company Profile</NavLink></li>
                            <li><NavLink to="/how-to-buy">How To Buy</NavLink></li>
                            <li><NavLink to="/customer-reviews">Customer Reviews</NavLink></li>
                            <li><NavLink to="/terms-condition">Terms/Condition</NavLink></li>
                            <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                            <li><NavLink to="/faq-page">FAQ</NavLink></li>
                        </ul>
                    </li>
                </ul>
            </nav>
          </div>
        </div>
    );
};

export default Navbar;